export const LAST_URL = 'LAST_URL'
export const PATIENT_PRIVACY_URL = 'PATIENT_PRIVACY_URL'
export const PATIENT_PRIVACY_URL_LABEL = 'PATIENT_PRIVACY_URL_LABEL'
export const SIDENAV_LINKS = 'SIDENAV_LINKS'


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/website/types.js
// module id = null
// module chunks = 